module.exports = __webpack_public_path__ + "img/book@2x.d1e235ef.png";